import { render } from "./FooterSectionFour.vue?vue&type=template&id=056442d8"
import script from "./FooterSectionFour.vue?vue&type=script&lang=js"
export * from "./FooterSectionFour.vue?vue&type=script&lang=js"

import exportComponent from "/Users/larijuva/suha-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__